import { PondFilters, PondName } from 'modules/pond/api/types'
import { atom } from 'recoil'

export const selectedPondState = atom<PondName | null>({
  key: 'selectedPondState',
  default: null,
})

export const selectedCycleIdState = atom<string | null>({
  key: 'selectedCycleIdState',
  default: null,
})

export const selectPondFiltersState = atom<PondFilters>({
  key: 'pondGridFiltersState',
  default: {
    sortBy: '',
    sortOrder: '',
    pondType: '',
    pondName: '',
  },
})

export const isSettingEditState = atom({
  key: 'isSettingEditState',
  default: false,
})
